import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { EegUserData } from '@/lib/eeg/types/user-data';

export interface EegUserDataStoreData {
  userData: EegUserData | null;
}

export interface EegUserDataState extends EegUserDataStoreData {
  setUserData: (userData: EegUserData | null) => void;
}

const useEegUserDataStore = create<EegUserDataState>()(
  devtools(
    subscribeWithSelector((set) => {
      return {
        userData: null,
        setUserData: (userData: EegUserData | null) => {
          set(
            {
              userData,
            },
            undefined,
            'useEegUserDataStore/setUserData'
          );
        },
      };
    })
  )
);

export default useEegUserDataStore;
